import { capitalize, markRaw } from 'vue';

import {
  IconColoredPollenHigh2,
  IconColoredPollenLow2,
  IconColoredPollenMedium2,
  IconColoredPollenNone,
  IconColoredPollenVeryHigh,
  IconColoredPollenVeryLow,
} from '@/common/icons/colored';
import i18n from '@/vueI18n';

export default function allPollens() {
  return [
    {
      id: 'VERY HIGH',
      name: capitalize(i18n.global.t('options.pollen.veryHigh')),
      icon: markRaw(IconColoredPollenVeryHigh),
    },
    { id: 'HIGH', name: capitalize(i18n.global.t('options.pollen.high')), icon: markRaw(IconColoredPollenHigh2) },
    { id: 'MEDIUM', name: capitalize(i18n.global.t('options.pollen.medium')), icon: markRaw(IconColoredPollenMedium2) },
    { id: 'LOW', name: capitalize(i18n.global.t('options.pollen.low')), icon: markRaw(IconColoredPollenLow2) },
    {
      id: 'VERY LOW',
      name: capitalize(i18n.global.t('options.pollen.veryLow')),
      icon: markRaw(IconColoredPollenVeryLow),
    },
    { id: 'NONE', name: capitalize(i18n.global.t('options.pollen.none')), icon: markRaw(IconColoredPollenNone) },
  ];
}
